import ResourcePreviewList from './ResourcePreviewList';

export default ResourcePreviewList;
